import React, { Suspense, lazy, useEffect } from "react";
import GoogleAnalytics from "react-ga";
import TagManager from "react-gtm-module";
import { Helmet } from "react-helmet";
import { Provider } from "react-redux";
import { Router, Switch } from "react-router-dom";
import { Worker } from "@phuocng/react-pdf-viewer";
import { v4 as uuidv4 } from "uuid";

import { PublicRoute, PrivateRoute } from "./components/CustomRoutes";
import FirebaseProvider from "./firebase/FirebaseContext";
import store from "./store";
import history from "./history";

import CertificationApprovalPage, {
  CertificatePage,
} from "./pages/certification/ApprovalPage";
import FAQPage from "./pages/static/FAQPage";
import LandingPage from "./pages/static/LandingPage";
import ProgramPage from "./pages/static/ProgramPage";
import QualificationsPage from "./pages/static/QualificationsPage";
import TOCPage from "./pages/static/TOCPage";
import {
  GOOGLE_TRACKING_ID,
  GOOGLE_TRACKING_VERSION,
  GOOGLE_TAG_MANAGER,
} from "./config";

const AppBase = lazy(() => import("./pages/AppBase"));
const tagManagerArgs = {
  gtmId: GOOGLE_TAG_MANAGER,
};
function App() {
  useEffect(() => {
    GoogleAnalytics.initialize(GOOGLE_TRACKING_ID, {
      gaOptions: {
        name: "certification",
      },
    });
    GoogleAnalytics.set({
      userId: uuidv4(),
      version: GOOGLE_TRACKING_VERSION,
    });

    TagManager.initialize(tagManagerArgs);

    history.listen((location) => {
      if (location.pathname) {
        GoogleAnalytics.set({ page: location.pathname });
        GoogleAnalytics.pageview(location.pathname);
      }
    });
  }, []);

  return (
    <Provider store={store}>
      <FirebaseProvider>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
          <Router history={history}>
            <div className="App">
              <Helmet>
                <script
                  id="ze-snippet"
                  src="https://static.zdassets.com/ekr/snippet.js?key=835f8d9f-ba7a-4ebd-8cb3-6902f2c6e143"
                >
                  {" "}
                </script>
              </Helmet>
              <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                  {/* <PublicRoute component={AppBase} exact path="/" /> */}
                  <PublicRoute component={LandingPage} exact path="/" />
                  <PrivateRoute
                    component={CertificationApprovalPage}
                    exact
                    path="/certificate"
                  />
                  <PublicRoute
                    component={CertificatePage}
                    exact
                    // Expect the number provided via `certificateData.certificateNumber`
                    // This should allow public lookup of the certification
                    path="/certificate/:certificateNumber"
                  />
                  <PublicRoute
                    component={QualificationsPage}
                    exact
                    path="/page/qualifications"
                  />
                  <PublicRoute
                    component={ProgramPage}
                    exact
                    path="/page/benefits"
                  />
                  <PublicRoute component={FAQPage} exact path="/page/faq" />
                  <PublicRoute component={TOCPage} exact path="/page/toc" />
                  <PublicRoute component={AppBase} path="/*" />
                </Switch>
              </Suspense>
            </div>
          </Router>
        </Worker>
      </FirebaseProvider>
    </Provider>
  );
}

export default App;
